module.exports = __webpack_public_path__ + "media/images/icons/cart-ba7b2951b041545cd40ea131c49c7055.svg";